export default "/ethereum.fd341b91fde455138b00026525ffe3ff.svg";